import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const RedditIconSvg = ({
  color = "primary",
  bg = "#f5f9f9",
  iconStyle,
  ...rest
}) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-4.1 0 28 16.5"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="m19.2103 8.98461c-.0412-1.11382-.9764-1.9836-2.0936-1.9458-.4952.01721-.966.22006-1.3235.56029-1.5745-1.07263-3.4241-1.66058-5.3253-1.70176l.8971-4.31449 2.9601.62237c.0823.75975.7631 1.3099 1.5228 1.22722.7598-.08237 1.3099-.76313 1.2273-1.52289-.0827-.75975-.7632-1.309896-1.5229-1.22722-.4368.044565-.8286.299045-1.045.67739l-3.3897-.67739c-.2302-.051634-.4607.092817-.5123.32671v.00676l-1.02102 4.79917c-1.9252.03104-3.79877.62237-5.39388 1.70176-.81139-.76313-2.09025-.72533-2.85338.08944-.763135.81139-.725332 2.09024.08944 2.85333.15828.1479.34023.2751.54307.3646-.01383.2028-.01383.4057 0 .6085 0 3.0974 3.60976 5.6173 8.06167 5.6173 4.4518 0 8.0616-2.5165 8.0616-5.6173.0138-.2028.0138-.4057 0-.6085.6946-.3473 1.1313-1.06253 1.1175-1.83949zm-13.83048 1.38549c0-.76312.62237-1.38549 1.3855-1.38549.76314 0 1.38551.62237 1.38551 1.38549 0 .7631-.62237 1.3855-1.38551 1.3855-.76651-.0071-1.3855-.6224-1.3855-1.3855zm8.03428 3.8572v-.055c-.9832.7391-2.1865 1.1172-3.41736 1.0658-1.23091.0517-2.43386-.3267-3.41736-1.0658-.13062-.1583-.10665-.3953.05164-.5259.13738-.1134.33346-.1134.47453 0 .83198.6085 1.84622.918 2.87736.8698 1.03149.055 2.04909-.2407 2.89119-.8421.1512-.1479.3986-.1445.5468.0067.1478.1512.1444.3986-.0068.5465zm-.189-2.3721c-.024 0-.0446 0-.0689 0l.0105-.0516c-.7632 0-1.3855-.6224-1.3855-1.3855 0-.76318.6223-1.38555 1.3855-1.38555.7631 0 1.3855.62237 1.3855 1.38555.0307.7634-.564 1.4061-1.3271 1.4371z"
        fill={color}
      />
    </Svg>
  )
}

export default RedditIconSvg
